import React from 'react';
import { HexColorPicker } from "react-colorful";

interface Props {
  color: string;
  setColor: (newColor: string) => void;
}

const AnalystColor: React.FC<Props> = ({ color, setColor }) => {
  return <HexColorPicker style={{ position: 'absolute', zIndex: 99999 }} color={color} onChange={setColor} />;
}

export default AnalystColor;
